import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Vet icon
 *
 * @category Medical
 */
const Vet = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M7.626 18.5c-1.45-.2-2.69-2.5-2.4-4.17.23-1.33 1.43-2.5 2.82-2.49 2.62.03 2.47 3.9 1.49 5.48-.6.95-1.27 1.27-1.91 1.18m.01-5.87c-2.11.29-1.99 5.18.42 4.73 1.6-.57 1.71-4.35-.29-4.73h-.14zm16.85 5.87c-3.21-.29-3.33-6.36-.08-6.77 3.36-.22 3.73 6.44.24 6.77zm-.04-5.76c-.54.1-1.07.55-1.3 1.26-.41 1.28.62 4.74 2.44 3.02.69-.65.65-2.24.42-3.08-.26-.96-.93-1.32-1.57-1.2zm-11.95-.19c-2.25.18-3.23-3.82-2.43-5.81.01-.02.02-.05.03-.07.51-1.19 1.65-1.97 2.96-1.62 2.89.76 3.1 5.21.92 6.86-.54.41-1.03.61-1.48.64m.01-6.77c-2.36-.36-2.67 4.64-.43 5.51.09.04.19.06.28.08 2.81.59 2.65-4.62.61-5.46-.16-.07-.32-.11-.47-.13zm7.12 6.61c-.43-.01-.86-.13-1.23-.36-1.02-.63-1.44-1.91-1.5-3.1-.05-.9.08-1.83.54-2.59.97-1.62 3.29-1.81 4.39-.23.49.7.67 1.58.69 2.44.03 1.41-.48 2.99-1.75 3.61-.35.17-.75.25-1.14.24zm0-6.61c-2.44.09-2.39 5.08-.02 5.4 2.48.33 2.7-4.6.63-5.3-.22-.07-.42-.1-.61-.1m-8.32 21.11c-3.21-.3-4.69-4.26-2.26-6.51 1.6-1.26 2.09-2.99 3.13-4.64 1.63-2.19 4.96-2.56 7.06-.83 1.28.95 1.61 2.59 2.45 3.85.44.63 1.11 1.18 1.63 1.76 1.93 2.04 1.14 5.14-1.33 6.08-1.6.61-3.74.07-5.33.06-1.5-.09-3.66.31-5.18.23l-.17-.02zm4.52-12.06c-2.8.15-3.69 3.26-5.23 5.16-1.16 1.27-2.56 3.15-1.2 4.77 1.57 1.89 4.75.88 7.06 1.01 1.59-.01 3.24.39 4.91-.11 3.53-1.17 1.65-4.32-.15-6.18-1.31-1.97-2.47-4.83-5.22-4.66h-.17z"
        />
      </svg>
    );
  }
);

Vet.displayName = 'Vet';

export { Vet };
